import React from "react";
import { CustomActivityTypeManager } from "@/components/activity/CustomActivityTypeManager";
import { useRequireAuth } from "@/hooks/useRequireAuth";

export default function CustomActivityTypes() {
  useRequireAuth();
  
  return (
    <div className="container mx-auto p-6">
      <CustomActivityTypeManager />
    </div>
  );
}